import { Form, Modal } from "react-bootstrap";
import styles from "./SignUpDone.module.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/Images/white_logo.png";
import "../../assets/Styles/Common.css";
import { useTranslation } from "react-i18next";
import AppStore from "../../assets/Images/appstore.png";
import PlayStore from "../../assets/Images/playstore.png";
import { useDispatch, useSelector } from "react-redux";
import { clearForm, signUpCurrentUser } from "../../store/slices/UserSlice";
import { useForm } from "react-hook-form";
import { useEffect } from "react";

function SignupDone({ isOpen, setIsOpen }) {
  const { signupData1, signupUser } = useSelector((state) => state.user);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("userToken")
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };


  const subdomain = getCookie("subdomain") || localStorage.getItem("subdomain");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const packageName = searchParams.get("packageName") === "true";
  const planSection = searchParams.get("planSection") === "true";
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  const type = queryParams.get("plan_type");
  // console.log("Subdomain from cookie:", subdomain);
  // const subdomain = localStorage.getItem("subdomain");

  const {
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (formdata) => {
    dispatch(clearForm());
  };

  // --------function for open component top of the page ----------
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const signUpUser = async () => {
    const packageQuery = packageName && id ? `?packageName=true&id=${id}&authToken=${token}` : "";
    const planQuery = planSection && id ? `?planSection=true&id=${id}&plan_type=${type}&authToken=${token}` : "";
    dispatch(signUpCurrentUser(signupUser))
      if (packageName && id) {
      const redirectUrl = subdomain
        ? `https://${subdomain}.${process.env.REACT_APP_MAIN_URL}${process.env.REACT_APP_PARAM_URL}subscription/detail${packageQuery}`
        : `https://${process.env.REACT_APP_MAIN_URL}${process.env.REACT_APP_PARAM_URL}subscription/detail${packageQuery}`;
      window.location.href = redirectUrl;

    // Priority 2: Redirect to plan section
    } else if (planSection && id) {
      const redirectUrl = subdomain
        ? `https://${subdomain}.${process.env.REACT_APP_MAIN_URL}${process.env.REACT_APP_PARAM_URL}exclusive/paypal${planQuery}`
        : `https://${process.env.REACT_APP_MAIN_URL}${process.env.REACT_APP_PARAM_URL}exclusive/paypal${planQuery}`;
      window.location.href = redirectUrl;

    // Priority 3: Default profile redirect
    } else {
      const profileUrl = subdomain
        ? `https://${subdomain}.${process.env.REACT_APP_MAIN_URL}${process.env.REACT_APP_PARAM_URL}profile?token=${token}`
        : "/profile";

      if (subdomain) {
        window.location.href = profileUrl;
      } else {
        navigate(profileUrl);
      }
    }
  };

  return (
    <>
      <div>
        <div>
          <Modal
            className="successModal"
            show={isOpen}
            onHide={() => setIsOpen(false)}
            backdrop="static"
            centered
          >
            <Modal.Body>
              <div className={styles.FormBlock}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <div className={styles.FormSection}>
                    <div className={styles.SignupTitle}>
                      <img src={Logo} alt="logo" />
                      <h2>{t("WELCOME_TEXT")}</h2>
                      <p>@{signupData1.userName}</p>
                    </div>
                    <div className={styles.signupPara}>
                      <h5>{t("CREATE_USER_ACCOUNT")}</h5>
                    </div>
                    <div className={styles.doneBtn}>
                      <button onClick={signUpUser}>{t("DONE_SHOW")}</button>
                    </div>
                    <div className={styles.GetApp}>
                      <p>{t("GET_THE_APP")}</p>
                      <div className={styles.AppLink}>
                        <NavLink to={process.env.REACT_APP_APP_STORE_LINKS} target="_blank">
                          <img src={AppStore} alt="app store" />
                        </NavLink>
                        <NavLink to={process.env.REACT_APP_PLAY_STORE_LINKS} target="_blank">
                          <img src={PlayStore} alt="play store" />
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default SignupDone;
